import * as React from "react";

import { Button, Collapse } from "@blueprintjs/core";
import WidgetsOutlinedIcon from "@material-ui/icons/BusinessOutlined";
import CardGiftcardOutlinedIcon from "@material-ui/icons/CardGiftcardOutlined";
import CopyrightOutlinedIcon from "@material-ui/icons/CopyrightOutlined";
import CreditCardOutlinedIcon from "@material-ui/icons/CreditCardOutlined";
import LocalShippingOutlinedIcon from "@material-ui/icons/LocalShippingOutlined";
import MoveToInboxOutlinedIcon from "@material-ui/icons/MoveToInboxOutlined";
import SwapHorizontalCircleOutlinedIcon from "@material-ui/icons/SwapHorizontalCircleOutlined";
import { WithTranslation, withTranslation } from "react-i18next";
import { RouteComponentProps, withRouter } from "react-router";
import { compose } from "recompose";
import Topic from "~/components/CustomerSupport/Topic";
import { shopConfig } from "~/helpers/shopConfig";
import { StyledCallout as Callout } from "~/layouts/StyledCallout";
import { StyledCard as Card } from "~/layouts/StyledCard";
import CardList from "../CustomerSupport/CardList";

const ICONS = {
  b2b: WidgetsOutlinedIcon,
  copyright: CopyrightOutlinedIcon,
  giftcard: CardGiftcardOutlinedIcon,
  orders: MoveToInboxOutlinedIcon,
  payments: CreditCardOutlinedIcon,
  returns: SwapHorizontalCircleOutlinedIcon,
  shipping: LocalShippingOutlinedIcon
};

interface ITopic {
  key:
    | "orders"
    | "shipping"
    | "giftcard"
    | "copyright"
    | "returns"
    | "payments"
    | "b2b";
  title: string;
  description: string;
}

class TopicsList extends React.Component<
  WithTranslation & RouteComponentProps
> {
  public state = {
    isOpen: false
  };

  public topicsHeaderRef = React.createRef<HTMLDivElement>();

  public render() {
    const { t } = this.props;

    const topics: ITopic[] = t("topics", {
      returnObjects: true,
      ...shopConfig
    });

    if (!topics) {
      return null;
    }

    return (
      <React.Fragment>
        <div ref={this.topicsHeaderRef}>
          <Callout
            title={t("topicsHeader.title")}
            style={{
              backgroundColor: "transparent",
              marginTop: "12px",
              textAlign: "center"
            }}
          >
            <div>{t("topicsHeader.description")}</div>
          </Callout>
        </div>

        {topics.slice(0, 4).map(topic => this.renderCard(topic))}

        {!this.state.isOpen && (
          <Button
            onClick={this.handleClick}
            style={{ background: "transparent" }}
          >
            {t("helpers.showMore")}
          </Button>
        )}

        <Collapse isOpen={this.state.isOpen}>
          <CardList>
            {topics
              .slice(4, topics.length)
              .map(topic => this.renderCard(topic))}
          </CardList>
        </Collapse>

        {this.state.isOpen && (
          <Button
            onClick={this.handleClick}
            style={{ background: "transparent" }}
          >
            {t("helpers.showLess")}
          </Button>
        )}
      </React.Fragment>
    );
  }

  public componentDidMount() {
    this.handleScrollToFAQ();
  }

  public componentDidUpdate() {
    this.handleScrollToFAQ();
  }

  private renderCard = (topic: ITopic) => {
    return (
      <Card
        key={topic.key}
        interactive={true}
        onClick={this.handleTopicClick(topic.key)}
      >
        <Topic
          chevron={true}
          title={topic.title}
          icon={ICONS[topic.key]}
          description={topic.description}
        />
      </Card>
    );
  };

  private handleScrollToFAQ = () => {
    const { location } = this.props;

    if (location.hash === "#faq" && this.topicsHeaderRef.current) {
      this.topicsHeaderRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  private handleClick = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  private handleTopicClick = (topic: string) => (
    event: React.MouseEvent<HTMLDivElement>
  ) => {
    const { history } = this.props;

    switch (topic) {
      case "b2b":
        history.push({ pathname: "/b2b" });
        break;
      case "copyright":
        (window as any).location.pathname = "/pages/report_product";
        break;
      case "giftcard":
        history.push({ pathname: "/giftcard" });
        break;
      default:
        history.push({ pathname: `/faq/${topic}` });
    }
  };
}

export default compose(
  withTranslation("faq"),
  withRouter
)(TopicsList);



// WEBPACK FOOTER //
// ./src/components/FAQ/TopicsList.tsx